import React from 'react';
import { DropletsIcon, SparklesIcon, CrownIcon, CheckIcon } from 'lucide-react';
import type { MembershipPlan, PlanIcon } from '../../data/membership';
import { selectServiceAndScroll } from '../../utils/booking';
const icons: Record<PlanIcon, React.ComponentType<{
  className?: string;
}>> = {
  droplet: DropletsIcon,
  sparkle: SparklesIcon,
  crown: CrownIcon
};
interface MembershipPlansProps {
  plans: MembershipPlan[];
  perWash: string;
}
export function MembershipPlans({
  plans,
  perWash
}: MembershipPlansProps) {
  return <div className="mt-12 grid gap-6 md:grid-cols-3 md:items-stretch" data-id="element-304" data-mp="qp2jv4nz4q5k">
      {plans.map(plan => {
      const Icon = icons[plan.icon];
      const featured = plan.featured;
      return <article key={plan.id} className={`relative flex flex-col rounded-xl border p-7 transition-shadow duration-200 hover:shadow-lift ${featured ? 'border-brand-orange bg-navy shadow-lift md:-my-3 md:py-10' : 'border-navy/10 bg-white shadow-card'}`} data-id="element-305" data-mp="gy7wty2wlmj2">
            <div className="flex items-center justify-between gap-3" data-id="element-306" data-mp="3p54djk5gazf1">
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${featured ? 'bg-brand-orange/15 text-brand-orange' : 'bg-mist text-brand-blue'}`} data-id="element-307" data-mp="3p2rmmhhptepu">
                <Icon className="h-5 w-5" data-id="element-308" data-mp="gohuyhn3vmm6" />
              </span>
              {plan.badge && <span className="rounded-full bg-brand-orange px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-309" data-mp="cnz1kj5ke8hv">
                  {plan.badge}
                </span>}
            </div>

            <h3 className={`mt-5 font-display text-xl font-bold ${featured ? 'text-white' : 'text-navy'}`} data-id="element-310" data-mp="lp5l713ifzfc">
              {plan.name}
            </h3>
            <p className={`mt-1 text-sm ${featured ? 'text-white/60' : 'text-ink/60'}`} data-id="element-311" data-mp="2ngsfpcmm2cgk">
              {plan.bestFor}
            </p>

            <p className={`mt-5 text-xs font-medium ${featured ? 'text-brand-cyan' : 'text-brand-blue'}`} data-id="element-312" data-mp="ref86ajqk5gz">
              {perWash} · {plan.billing}
            </p>

            <div className={`my-6 h-px ${featured ? 'bg-white/10' : 'bg-navy/10'}`} data-id="element-313" data-mp="15bvk21kswrg4" />

            {plan.intro && <p className={`mb-3 text-sm font-semibold ${featured ? 'text-white' : 'text-navy'}`} data-id="element-314" data-mp="1ac01bttj9q7e">
                {plan.intro}
              </p>}
            <ul className="space-y-2.5" data-id="element-315" data-mp="1k0hy7zyozd5r">
              {plan.features.map(feature => <li key={feature} className={`flex items-start gap-2.5 text-sm ${featured ? 'text-white/85' : 'text-ink/80'}`} data-id="element-316" data-mp="1o2d5dl3b0krg">
                  <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${featured ? 'text-brand-orange' : 'text-brand-blue'}`} aria-hidden="true" data-id="element-317" data-mp="1y1uc85ual4p0" />
                  {feature}
                </li>)}
            </ul>

            <div className="mt-auto pt-8" data-id="element-318" data-mp="1y71y46cwp76g">
              <button type="button" onClick={() => selectServiceAndScroll(plan.optionLabel)} className={`flex min-h-[48px] w-full items-center justify-center rounded-lg px-6 text-base font-semibold transition-colors duration-150 ${featured ? 'bg-brand-orange text-white hover:bg-brand-orangeDark' : 'bg-navy text-white hover:bg-navy-700'}`} data-id="element-319" data-mp="1u581qa9qupc3">
                {plan.cta}
              </button>
            </div>
          </article>;
    })}
    </div>;
}